import './PopupNewsletterModal.scss';

import { b2x } from '@b2x/react/src';

import { NewsletterContentType } from './contentTypes';
import { NewsletterForm } from './NewsletterForm';

interface PopupNewsletterModalProps extends b2x.ModalProps {}

export const PopupNewsletterModal = (modalProps: PopupNewsletterModalProps) => {
  const content = b2x.useContent<NewsletterContentType>('NEWSLETTER_POPUP');
  return (
    <b2x.Modal {...modalProps} className="popup-newsletter-modal">
      <div className="popup-image">
        {content?.body.asset && <b2x.AssetV2 {...content.body.asset} fluid />}
        <b2x.ModalHeader title="" />
      </div>
      <div className="bg-black">
        <b2x.ModalBody className="pb-5">
          <div className="text-center text-white newsletter-form-box">
            <p className="pt-2 h2">{b2x.formatHtml(content?.body.title)}</p>
            <p className="pb-2">{b2x.formatHtml(content?.body.subTitle)}</p>
            <NewsletterForm emailFieldStyle="textInput" source="website-modal" />
          </div>
        </b2x.ModalBody>
      </div>
    </b2x.Modal>
  );
};

export const usePopupNewsletterModal = (props?: PopupNewsletterModalProps) =>
  b2x.useStaticModal(PopupNewsletterModal, 'modal', props);
